import cx from 'classnames'
import { generatePath, useHistory } from 'react-router-dom'
import { Button } from 'blaze-ui/Button'
import { Text } from 'blaze-ui/Text/Text'
import { useModals } from 'almanac-ui/Modal'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { CONTENT_PREFERENCES_PATH } from 'paths'
import Styles from './MissingAvatarsCallout.module.scss'

interface MissingAvatarsCalloutProps {
  compact?: boolean
  className?: string
}

export const MissingAvatarsCallout = ({ compact, className }: MissingAvatarsCalloutProps) => {
  const workspaceId = useCurrentWorkspaceId()
  const { closeAllModals } = useModals()
  const history = useHistory()

  const handleCreateAvatar = () => {
    closeAllModals()
    history.push(generatePath(CONTENT_PREFERENCES_PATH, { workspaceId }) + '#avatars')
  }

  return (
    <div className={cx(Styles.callout, { [Styles.compact]: compact }, className)}>
      <Text variant="secondary" color="var(--dark-60)">
        No verified avatars available.
      </Text>
      <Button variant="primary" size="sm" onPress={handleCreateAvatar}>
        Create avatar
      </Button>
    </div>
  )
}
